const getErrors = state => state.site.errors;
export const getLoadSitesWithAliasesError = state => getErrors(state).loadSitesWithAliasesError;
export const getLoadActiveSitesError = state => getErrors(state).loadActiveSitesError;
export const getLoadSiteError = state => getErrors(state).loadSiteError;
export const getSwitchSiteStatusError = state => getErrors(state).switchSiteStatusError;
export const getDeleteSiteError = state => getErrors(state).deleteSiteError;
export const getSiteFormStructureError = state => getErrors(state).getSiteFormStructureError;
